
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBackwardStopped as ObiBackwardStoppedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-backward-stopped.js';
 
 
 

 
 export const ObiBackwardStopped = createComponent({
   react: React,
   tagName: 'obi-backward-stopped',
   elementClass: ObiBackwardStoppedElement,
   events: {
     
   }
  });
 
 